import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import decodables from '@/common/data/decodables.json';
import { Decodable, DecodableStory } from '@/common/types/decodable';

const DigitalLibrary: React.FC = () => {
  const navigate = useNavigate();

  // Won't need to filter once all of json is in correct structure
  // Just render with decodables.map(...)
  const filteredDecodables = decodables.reduce((acc, d) => {
    if (d.level < 8 || d.level > 14 || d.level === 10) return acc; // skip all but levels 8-14, lvl 10 is also wrong
    return [...acc, d as Decodable];
  }, [] as Decodable[]);

  const handleBookClick = (
    level: number,
    levelInfo: string,
    story: DecodableStory,
  ) => {
    navigate(`book/${encodeURIComponent(story.title)}`, {
      state: { level, levelInfo, story },
    });
  };

  return (
    <LibraryContainer>
      {filteredDecodables.map(({ level, levelInfo, decodables }) => (
        <LevelRow key={level}>
          <LevelInfo>
            Level {level}: {levelInfo}
          </LevelInfo>
          <BookShelf>
            {decodables.map((story, index) => (
              <BookContainer
                key={index}
                onClick={() => handleBookClick(level, levelInfo, story)}
              >
                <Book>
                  <BookTitle>{story.title}</BookTitle>
                </Book>
                <BookDetails>
                  <span>{story.pages.length} pages</span>
                  <span>{story.blurb}</span>
                </BookDetails>
              </BookContainer>
            ))}
          </BookShelf>
        </LevelRow>
      ))}
    </LibraryContainer>
  );
};

export default DigitalLibrary;

const LibraryContainer = styled.div`
  font-family: Arial, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`;

const LevelRow = styled.div`
  margin-bottom: 30px;
`;

const LevelInfo = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 10px;
`;

const BookShelf = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

const Book = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 200px;
  padding: 10px;

  opacity: 1;
  transition: opacity 0.2s ease-in-out;
`;

const BookDetails = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 150px;
  height: 200px;
  display: flex;
  padding: 10px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1em;
  text-align: center;
  line-height: 1.5;
  font-size: 1em;
  color: #666;

  opacity: 0;
  transition: opacity 0.2s ease-in-out;
`;

const BookContainer = styled.div`
  position: relative;
  background-color: #f0f0f0;
  border-radius: 5px 15px 15px 5px;
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.1);
  cursor: pointer;

  &:hover {
    ${Book} {
      opacity: 0;
    }

    ${BookDetails} {
      opacity: 1;
    }
  }
`;

const BookTitle = styled.h3`
  font-size: 1rem;
  text-align: center;
  margin: 0;
`;
